import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ChatsModule"
const debug = false

export class ChatsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.CHATS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                    = "Chats"
        this.description             = "The Chat module provides a convenient platform for real-time communication and collaboration within your workspace. This feature allows users to engage in instant messaging, share files, and exchange ideas seamlessly. With customizable settings, users can participate in direct (one-to-one) chats, group chats, and project-related discussions. The Chat module enhances team collaboration and facilitates efficient communication across projects."
        this.svgIcon                 = "isvg-one-to-one-chat"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "Productivity & Collaboration"
        this.settingsUrl             = "settings/chats"
        this.parentSection           = SettingsParentSection.PRODUCTIVITY

    }

    enable():void {
        super.enable()

        gd.layout.navigation.reset()
        gd.layout.navigation.reRender()
    }

    disable():void {
        super.disable()

        gd.layout.navigation.reset()
        gd.layout.navigation.reRender()
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}